import { useSWRFetch } from '@hooks/useSWRFetch';
import { TEN_MINUTES_IN_MS } from '@helpers/constants';
import { isEmptyString } from '@helpers/utils';
import { ArtistAlbum, ArtistAppearsOnResult } from './types';

export const useArtistAppearsOnInfo = (
  artistUri: string = '',
  page: number = 1,
  limit: number = 10,
): ArtistAppearsOnResult => {
  const searchParams = new URLSearchParams();
  const offset = (page - 1) * limit;

  searchParams.append('appearsOnPagination.offset', offset.toString());
  searchParams.append('appearsOnPagination.limit', limit.toString());

  const requestObject = {
    url: `v2/artist/${artistUri}/appearsOn?${new URLSearchParams(
      searchParams,
    )}`,
  };

  const canRequest = !isEmptyString(artistUri);

  const { data, error, isValidating, isLoading } = useSWRFetch<{
    appearsOn: ArtistAlbum[];
  }>(canRequest ? requestObject : null, {
    dedupingInterval: TEN_MINUTES_IN_MS,
    revalidateOnFocus: false,
  });

  return {
    data: {
      appearsOnInfo: data,
    },
    error,
    isValidating,
    isLoading,
  };
};
